<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Supervisor" subTitle="Editar" />

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small">
          <div class="card-header border-bottom">
            <h6 class="m-0">Informações do Supervisor</h6>
          </div>
          <!-- Content -->
          <supervisor-form ref="supervisorForm" />
          <div class="card-body p-6 pb-3 text-left">
            <Assignment
              storeName="supervisor"
              :onShowText="onShowText"
              :getAssociatedDistributors="getSupervisorDistributors"
              :syncAttacherDistributors="syncAttacherSupervisorDistributors"
            >
              <template v-slot:filters="slotProps">
                <div class="input-group mr-2">
                  <select-state
                    :model.sync="slotProps.paginationDetached.state"
                    :onChange="onChangeStates"
                  />
                </div>
              </template>
              <template v-slot:icon="slotProps">
                <router-link
                  class="d-flex justify-content-between align-content-center"
                  :to="{
                    name: 'admin-distributor-edit',
                    params: { id: slotProps.id },
                  }"
                  target="_blank"
                >
                  <i class="material-icons cursor-pointer icon_new_page">
                    open_in_new
                  </i>
                </router-link>
              </template>
            </Assignment>
          </div>
        </d-card>
      </d-col>
      <d-col lg="3" md="12" class="mt-lg-0 mt-4">
        <sidebar-actions :model="supervisor" @save="save" />
      </d-col>
    </d-row>
    <supervisor-imports />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import Assignment from '_shared/Assignment.vue';
import SelectState from '_shared/SelectState.vue';
import SupervisorForm from '../components/SupervisorForm.vue';
import SidebarActions from '../components/SidebarActions.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/SupervisorModel';
import SupervisorImports from '../components/SupervisorImports.vue';

export default {
  name: 'admin-supervisor-edit',
  components: {
    PageHeader,
    SupervisorForm,
    Assignment,
    SelectState,
    SidebarActions,
    SupervisorImports,
  },
  computed: {
    supervisor() {
      const { supervisor } = this.$store.state.supervisor;
      if (supervisor) {
        return supervisor;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'checkAdmin',
      'getSupervisor',
      'getSupervisorDistributors',
      'syncAttacherSupervisorDistributors',
    ]),
    getSupervisorModel(id) {
      this.getSupervisor(id)
        .then(response => {
          Events.$emit(_LOAD_MODEL_, response);
        })
        .catch(error => {
          this.activeAlert({ message: error, theme: 'danger' });
        });
    },
    save() {
      this.$refs.supervisorForm.save();
    },
    onShowText(item) {
      if (item.name && item.uf) return `${item.name} - ${item.uf}`;
      return item.name;
    },
    onChangeStates(value) {
      Events.$emit('update:pagination_detached_some_attributes', {
        state: value,
        skip: 0,
        page: 1,
      });
    },
  },
  mounted() {
    this.checkAdmin();
    if (this.$route.params.id) {
      this.getSupervisorModel(parseInt(this.$route.params.id, Number));
    }
  },
};
</script>
